export enum ReferralTargetAction {
  register = 'register',
  realOrder = 'real_order',
}

export const REFERRAL_TARGET_ACTIONS = Object.values(ReferralTargetAction);

export const REFERRAL_TARGET_ACTION_LABELS: Record<
  ReferralTargetAction,
  string
> = {
  [ReferralTargetAction.register]: 'Register',
  [ReferralTargetAction.realOrder]: 'Real order',
};

export enum ReferralPaymentStatus {
  success = 'success',
  pending = 'pending',
  failed = 'failed',
}

export const REFERRAL_PAYMENT_STATUSES = Object.values(ReferralPaymentStatus);

export const REFERRAL_PAYMENT_STATUS_LABELS: Record<
  ReferralPaymentStatus,
  string
> = {
  [ReferralPaymentStatus.success]: 'Success',
  [ReferralPaymentStatus.pending]: 'Pending',
  [ReferralPaymentStatus.failed]: 'Failed',
};

export interface ReferralRecord {
  masterAccountId: string;
  referralAccountId: string;
  registeredAt: Date;
  firstRealOrderAt: Date | null;
  targetAction: ReferralTargetAction;
  paymentAmount: number;
  paymentStatus: ReferralPaymentStatus;
  referralPnl: number;
}
